<template>
  <div>
    <VueSlickCarousel ref="slider" class="add-child-slider"
                      @beforeChange="changeCurrentSlide"
                      :infinite="false" :adaptiveHeight="false" :arrows="false" :dots="true">
      <div class="add-child-slider-item">
        <div class="content-block-title">{{ $lang.messages.add_profile.personalization }}</div>
        <div class="form-group">
          <label for="kidsname" class="form-label">{{ $lang.messages.settings.kid_info.kid_name }}</label>
          <input id="kidsname" type="text" value=""
                 @input="changeKidName($event.target.value)"
                 maxlength="15"
                 :placeholder="$lang.messages.add_profile.enter_name" class="form-control">
          <div class="form-error" v-if="nameError">{{ $lang.messages.add_profile.name_error }}</div>
        </div>
        <div class="form-group">
          <label class="form-label">{{ $lang.messages.settings.kid_info.kid_age }}</label>
          <label class="radio-wrapper" :class="{active: newProfileSettings.kidAge === '5-8'}">
            <input name="kidsAge" type="radio" class="radio-input" value="5-8"
                   :checked="newProfileSettings.kidAge === '5-8'"
                   @change="changeKidAge($event.target.value)">
            <span class="radio-check"></span>
            <span class="radio-label"><strong>5-8</strong>{{ $lang.messages.years }}</span>
          </label>
          <label class="radio-wrapper" :class="{active: newProfileSettings.kidAge === '9-12'}">
            <input name="kidsAge" type="radio" class="radio-input" value="9-12"
                   :checked="newProfileSettings.kidAge === '9-12'"
                   @change="changeKidAge($event.target.value)">
            <span class="radio-check"></span>
            <span class="radio-label"><strong>9-12</strong>{{ $lang.messages.years }}</span>
          </label>
          <label class="radio-wrapper" :class="{active: newProfileSettings.kidAge === '13+'}">
            <input name="kidsAge" type="radio" class="radio-input" value="13+"
                   :checked="newProfileSettings.kidAge === '13+'"
                   @change="changeKidAge($event.target.value)">
            <span class="radio-check"></span>
            <span class="radio-label"><strong>13+</strong>{{ $lang.messages.years }}</span>
          </label>
        </div>
        <UploadAvatar :profile="newProfileSettings" @showchooseavatar="showChooseAvatar = true"/>
        <div class="form-group mb-3">
          <label for="kidsPassword" class="form-label">{{$lang.messages.settings.kid_info.kid_password}}</label>
          <input id="kidsPassword" type="text" :value="newProfileSettings.kidPassword || ''"
                 @input="newProfileSettings.kidPassword = $event.target.value"
                 :placeholder="$lang.messages.add_profile.enter_password" class="form-control">
        </div>
      </div>
      <div class="add-child-slider-item">
        <div class="content-block-title">{{ $lang.messages.app.links.add_sites_to_allow }}</div>
        <div class="links-wrapper sites-links">
          <Link
            v-for="link in newProfileSettings.links"
            :key="link.id"
            v-bind="link"
            v-on:removelink="removeLink"
            v-on:editlink="editLink"
          />
        </div>
        <div class="text-bold mb-05" v-if="appListings.length > 0">{{ $lang.messages.app.links.applications }}</div>
        <div class="links-wrapper" v-if="appListings">
          <AppItem
              v-for="app in appListings"
              :key="app.packageName"
              v-bind="app"
              v-on:removeapp="removeApp"
              v-on:editapp="openAddApp"
          />
        </div>
        <hr class="mb-2">
        <div class="w-100 mb-2">
          <button class="btn btn-outline mr-1" @click="openAddApp" tabindex="-1">{{ $lang.messages.app.links.add_app }}</button>
          <button class="btn btn-outline" @click="openAddLink" tabindex="-1">
            {{ $lang.messages.app.links.add_site }}
          </button>
        </div>
      </div>
      <div class="add-child-slider-item">
        <div class="content-block-title mb-3">{{ $lang.messages.add_profile.choose_time }}</div>
        <div class="text-center mb-1">
          <img src="../assets/img/choose-time-image.svg" alt="choose time" class="m-auto">
        </div>
        <div class="form-group mb-3">
          <div class="form-label">{{ $lang.messages.free_dashboard.one_time_session.time_limit }}</div>
          <div class="form-control-icon">
            <i class="icon-timer icon-in-input"></i>
            <v-select
                class="w-100"
                :label="sessionLimitOptions.label"
                :value="sessionLimitOptions.find(item => item.value >= newProfileSettings.dailyLimit)"
                :clearable="false"
                :searchable="false"
                :appendToBody="true"
                @input="changeTimeLimit"
                :options="sessionLimitOptions"
            >
              <template slot="open-indicator">
                <svg class="vs__open-indicator" width="20" height="10" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED" stroke-width="2"/>
                </svg>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </VueSlickCarousel>
    <div class="add-child-slider-buttons">
      <button class="btn-prev" v-if="!this.isFirstSlide" @click="showPrevSlide"></button>
      <button class="btn btn-main -shadow" @click="showNextSlide">{{isLastSlide ? $lang.messages.create : $lang.messages.next}}</button>
    </div>
    <AddLinkModal
        :recommended="false"
        :linktitle="editLinkTitle"
        :linkurl="editLinkUrl"
        :linkId="editLinkId"
        v-on:addlink="addLink"
        v-on:removelink="removeLink"
        v-on:hidemodal="showAddLinkModal = false"
        v-if="showAddLinkModal"/>
    <Modal v-if="showChooseAvatar" @hidemodal="showChooseAvatar = false">
      <div slot="header">
        {{ $lang.messages.add_profile.change_avatar }}
      </div>
      <div slot="content">
        <ChooseAvatar
            @hidechooseavatar="showChooseAvatar = false"
            @changeavatar="changeAvatar"
            @changecustomavatar="changeCustomAvatar" />
      </div>
    </Modal>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import {mapState} from "vuex";
import {defaultProfileSettings} from "@/helpers/configs";
import Link from '@/components/Link'
import AddLinkModal from '@/components/AddLinkModal'
import saveSetting from "@/components/mixins/saveSetting";
import {db} from "@/fb/firebase";
import {sessionLimitOptions} from "@/helpers/configs";
import AppItem from "@/components/AppItem";
import UploadAvatar from "@/components/UploadAvatar";
import Modal from "@/components/common/Modal";
import ChooseAvatar from "@/components/ChooseAvatar";

export default {
  name: 'AddChildPopup',
  mixins: [saveSetting],
  data: function () {
    return {
      isAndroid: window.Android,
      avatarSrc: false,
      currentSlide: 0,
      isLastSlide: false,
      isFirstSlide: true,
      showAddLinkModal: false,
      editLinkTitle: '',
      editLinkUrl: '',
      editLinkId: null,
      newProfileSettings: JSON.parse(JSON.stringify(defaultProfileSettings)),
      addDeviceShow: false,
      profileKey: null,
      nameError: false,
      showChooseAvatar: false,
      sessionLimitOptions,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      profiles: state => state.accountData.profiles,
    }),
    appListings(){
      return this.profiles[this.profileKey] ? this.profiles[this.profileKey].appListings : []
    }
  },
  mounted() {
    this.profileKey = db.ref('users/' + this.user.uid).child('settings/profiles/')
        .push({}).key;
    this.$store.commit('temporaryProfileID', this.profileKey);
  },
  methods: {
    changeAvatar(id){
      this.newProfileSettings.defaultAvatarId = id
    },
    changeCustomAvatar(src){
      this.newProfileSettings.avatar = src
    },
    openAddLink(){
      this.showAddLinkModal = true
      this.editLinkTitle = ''
      this.editLinkUrl = ''
      this.editLinkId = null
    },
    editLink (link) {
      this.editLinkTitle = link.title
      this.editLinkUrl = link.url
      this.editLinkId = link.id
      this.showAddLinkModal = true
    },
    checkDuplicateLink(url) {
      const index = this.newProfileSettings.links ? this.newProfileSettings.links.findIndex(item => item.url === url) : null
      return index !== -1
    },
    addLink (link) {
      console.trace('link', link)
      this.showAddLinkModal = false
      if (this.editLinkId) {
        const item = this.newProfileSettings.links.find(item => item.id === this.editLinkId);
        if (this.checkDuplicateLink(link.url) && item.title === link.title) {
          this.$dtoast.pop({
            preset: "error",
            heading: `The site ${link.url} already in list`,
          });
        } else {
          const index = this.newProfileSettings.links.findIndex(item => item.id === this.editLinkId)
          this.newProfileSettings.links[index].title = link.title
          this.newProfileSettings.links[index].icon = link.icon
          this.newProfileSettings.links[index].url = link.url
          this.editLinkId = false
        }
      } else {
        if (this.checkDuplicateLink(link.url)) {
          this.$dtoast.pop({
            preset: "error",
            heading: `The site ${link.url} already in list`,
          });
        } else {
          this.newProfileSettings.links.push(link)
        }
      }
    },
    changeTimeLimit(value){
      this.newProfileSettings.dailyLimit = value.value
      this.newProfileSettings.todayDailyLimit = value.value
    },
    changeCurrentSlide(prevSlide, nextSlide){
      this.isLastSlide = false
      this.isFirstSlide = false
      this.currentSlide = nextSlide
      if (this.currentSlide === this.$refs.slider.$el.querySelectorAll('.slick-slide').length - 1){
        this.isLastSlide = true
      } else if(this.currentSlide === 0){
        this.isFirstSlide = true
      }
    },
    showNextSlide () {
      if(this.isLastSlide){
        this.addNewProfile()
      } else {
        if(this.newProfileSettings.kidName.trim() === '' || this.nameError ){
          this.nameError = true
          this.$refs.slider.goTo(0)
        } else {
          this.$refs.slider.next()
        }
      }
    },
    showPrevSlide () {
      this.isLastSlide = false
      this.$refs.slider.prev()
    },
    changeKidName(value){
      if(value.trim() === ''){
        this.nameError = true
      } else {
        this.nameError = false
        this.newProfileSettings.kidName = value.trim()
      }
    },
    changeKidAge(value){
      this.newProfileSettings.kidAge = value
    },
    removeLink (link) {
      if (this.newProfileSettings.links.length > 1) {
        const index = this.newProfileSettings.links.findIndex(item => item.id === link)
        this.newProfileSettings.links.splice(index, 1)
      } else {
        this.$dtoast.pop({
          preset: "error",
          heading: "You should have at least one site",
        });
      }
      this.showAddLinkModal = false
    },
    removeApp (name) {
      this.saveProfileSettings(this.profileKey, {
        appListings: this.appListings.filter(app => app.packageName !== name),
      })
    },
    addNewProfile () {
      if (this.newProfileSettings.kidName){
        this.saveProfileSettings(this.profileKey, Object.assign(this.newProfileSettings, {
          appListings: this.appListings
        }))
        this.$emit('closeaddchild')
      } else {
        this.nameError = true
        this.$refs.slider.goTo(0)
      }
    },
    openAddApp() {
      if (this.isAndroid) {
        this.isAndroid.onClickAddPhoneApps(this.profileKey);
      } else {
        this.$emit('adddeviceshow')
      }
    },
  },
  components: {
    UploadAvatar,
    VueSlickCarousel,
    Link,
    AddLinkModal,
    AppItem,
    Modal,
    ChooseAvatar
  }
}

</script>

<style lang="scss">
@import "../assets/styles/helpers";
.add-child-slider {
  padding: 20px;

  @include responsive-below($xs) {
    padding: 15px 0;
  }

  &-item {
    padding: 0 5px;
  }

  .links-wrapper {
    margin: 0;
    margin-bottom: 24px;

    @include responsive-below($xs){
      max-height: 300px;
      overflow: auto;
    }

    .link {
      flex: 0 0 calc(50% - 8px);
      max-width: calc(50% - 8px);

      @include responsive-below($xs){
        flex-basis: 100%;
        max-width: 100%;
      }
    }
  }
  
  &-buttons {
    text-align: right;
    padding: 0 20px 20px;
  }

  .slick-dots{
    width: auto;
    bottom: -35px;
    text-align: left;

    li button:before {
      content: "";
      background: #B4B6E4;
      border-radius: 6px;
      width: 27px;
      height: 3px;
    }

    li.slick-active button:before {
      background: #7B66F6;
    }
  }

  &.-pagination-static {
    .slick-dots {
      position: static;
      text-align: center;
      margin: 16px;
    }
  }
}

.btn-prev {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #FFFFFF;
  border: 1px solid #9485EF;
  position: relative;
  vertical-align: top;
  margin-right: 8px;
  cursor: pointer;
  transition: all 0.3s;

  &:before {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    transform: rotate(-45deg);
    border: 2px solid #9485EF;
    border-right: 0;
    border-bottom: 0;
    position: absolute;
    left: 17px;
    top: 15px;
    transition: all 0.3s;
  }

  &:hover {
    background: #9485EF;

    &:before {
      border-color: #fff;
    }
  }
}

.upload-avatars-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: calc(4*113px + 4*10px);
  max-height: 330px;
  margin: 0 auto;
  overflow: auto;

  .size-placeholder {
    display: none;
  }
  .avatar-holder {
    padding: 6px;
    cursor: pointer;
    overflow: visible;

    &.selected {
      background: #EBEFF5;
      box-shadow: 0px 1.18588px 0px rgba(255, 255, 255, 0.3), inset 0px 1.18588px 1.18588px rgba(0, 0, 0, 0.2);
    }

    img {
      background-color: #ddd;
      border-radius: 50%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    .remove-avatar-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #fff;

      &:hover {
        background-color: #EBEFF5;
      }

      svg {
        width: 12px;
      }
    }
  }
  @include responsive-below($xs){
    max-width: 100%;
    gap: 2%;
    max-height: 70vh;

    .size-placeholder {
      display: block;
    }
    .avatar-holder {
      height: auto;
      width: 32%;
      min-width: 0;
      margin-bottom: 2%;

      img {
        top: 6px;
        left: 6px;
        position: absolute;
        height: calc(100% - 12px);
        width: calc(100% - 12px);
      }
    }
  }
}

</style>
